import { invokeFastApi } from './fastapi';

export const fetchData = async <T>(datatype: string): Promise<T> => {
  return invokeFastApi({
    path: `/_fetchData/${datatype}`,
    method: 'GET',
  });
};
